"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M8.41 22H20c1.1 0 2-.9 2-2V8.39c0-.89-1.08-1.34-1.71-.71L7.7 20.29c-.63.63-.18 1.71.71 1.71z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M7.71 20.29c-.63.63-.19 1.71.7 1.71H18V9.98L7.71 20.29zm1.36-9.22L11 13l1.93-1.93c-1.07-1.06-2.79-1.06-3.86 0zm-.7-1.77c1.57-1.12 3.7-1.12 5.27 0 .36.26.85.22 1.16-.1.39-.39.35-1.06-.1-1.38-2.2-1.57-5.19-1.57-7.4 0-.45.32-.5.99-.1 1.38.32.32.81.36 1.17.1zm7.84-2.61c.34.28.83.28 1.14-.03l.12-.12c.35-.35.31-.92-.08-1.24-3.67-3.05-9.02-3.07-12.7-.06-.43.35-.47.99-.08 1.37.32.33.84.37 1.19.08 3.01-2.48 7.4-2.48 10.41 0z"
})), 'CellWifiRounded');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/CellWifiRounded.js
// module id = 1829
// module chunks = 0